import axios from "../../../../../../../api/axiosInstance";
import {
  FetchCampaignJobStatusDataRequest,
  FetchCampaignJobStatusDataResponse,
} from "./types";

export const fetchStochasticClientMailData = async (
  requestParams: FetchCampaignJobStatusDataRequest = {},
): Promise<FetchCampaignJobStatusDataResponse> => {
  const response = await axios.get<FetchCampaignJobStatusDataResponse>(
    `/api/private/stochastic/campaign-job-status-data`,
    {
      params: requestParams,
    },
  );

  return response.data;
};
